<template>
  <b-form @submit.prevent="onSubmit">
    <h3>Zmiana hasła</h3>

    <b-form-group label="Stare hasło">
      <b-form-input
        v-model="oldPassword"
        :type="passwordType"
        autocomplete="off"
        :state="$v.oldPassword.$error? false : null"
        @input="$v.oldPassword.$reset()"
      />
      <b-form-invalid-feedback>
        <div v-if="!$v.oldPassword.required">To pole jest wymagane</div>
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Nowe hasło">
      <b-form-input
        v-model="newPasssword"
        :type="passwordType"
        autocomplete="off"
        :state="$v.newPasssword.$error? false : null"
        @input="$v.newPasssword.$reset()"
      />
      <b-form-invalid-feedback>To pole jest wymagane</b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="Powtórz hasło">
      <b-form-input
        v-model="confirmNewPassword"
        :type="passwordType"
        autocomplete="off"
        :state="$v.confirmNewPassword.$error? false : null"
        @input="$v.confirmNewPassword.$reset()"
      />
      <b-form-invalid-feedback>
        <div v-if="!$v.confirmNewPassword.required">To pole jest wymagane</div>
        <div
          v-if="!$v.confirmNewPassword.sameAsNewPassword"
        >Potwierdzenie musi być takie samo jak podane hasło</div>
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group>
      <b-button
        class="float-right"
        type="submit"
        variant="primary"
        :disabled="loading"
        @click="$v.$touch"
      >
        <span v-show="!loading">Zmień hasło</span>
        <span v-show="loading">
          <b-spinner small label="Loading..."></b-spinner>
        </span>
      </b-button>
    </b-form-group>
  </b-form>
</template>

<script>
import { axios, tokenStore, eventBus } from "@/_infrastructure";
import { required, sameAs } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      oldPassword: "",
      newPasssword: "",
      confirmNewPassword: "",

      hidePassword: true,
      loading: false
    };
  },
  validations: {
    oldPassword: {
      required
    },
    newPasssword: {
      required
    },
    confirmNewPassword: {
      required,
      sameAsNewPassword: sameAs("newPasssword")
    }
  },
  computed: {
    passwordType() {
      return this.hidePassword ? "password" : "text";
    },
    passwordIcon() {
      return this.hidePassword ? "eye" : "eye-slash";
    }
  },
  methods: {
    onSubmit() {
      if (!this.$v.$error) {
        this.loading = true;

        axios
          .post("/UserProfile/changePassword", {
            OldPassword: this.oldPassword,
            NewPassword: this.newPasssword,
            confirmNewPassword: this.confirmNewPassword
          })
          .then(() => {
            this.oldPassword = "";
            this.newPasssword = "";
            this.confirmNewPassword = "";
            this.$v.$reset();
            eventBus.$emit("notify-success", "Hasło zostało zmienione");
          })
          .catch(error => eventBus.$emit("unhandled-error", error))
          .then(() => (this.loading = false));
      }
    },
    goto(url) {
      this.$router.push(url);
    }
  }
};
</script>

<style lang="scss" scoped>
fieldset.form-group {
  width: 90%;
}
</style>